/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Sec_Pg_L6Inputs */

const en_mk_sec_pg_l6 = /** @type {(inputs: Mk_Sec_Pg_L6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delete a workspace and everything in it`)
};

const id_mk_sec_pg_l6 = /** @type {(inputs: Mk_Sec_Pg_L6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hapus workspace beserta isinya`)
};

/**
* | output |
* | --- |
* | "Delete a workspace and everything in it" |
*
* @param {Mk_Sec_Pg_L6Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_sec_pg_l6 = /** @type {((inputs?: Mk_Sec_Pg_L6Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Sec_Pg_L6Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_sec_pg_l6(inputs)
	return en_mk_sec_pg_l6(inputs)
});